var a = /* @__PURE__ */ ((t) => (t.Https = "https://", t.Mailto = "mailto:", t.Tel = "tel:", t))(a || {});
export {
  a as UrlSchemeEnum
};
